import React from 'react';
import { withRouter } from 'react-router-dom';
import './newUserGuide.less';
import ShowModal from './../showModal/index.jsx';
import MyLoading from './../showLoading/showLoading';
import { Loading } from 'element-react';

import { TaoteAuthRequest,GetQuickGuideDataRequest,AddSiteLogRequest,AddSiteLogByShopRequest } from '../../utils/api';
import { event } from 'jquery';
import { systemConfig,getLoginShopInfo,getTaoteId,getZkShopName,isNotNull,loadZhuKeToken,getToken,funSplitType } from '../../utils/http';
import { getStorage,setStorage} from '../../utils/common';

class NewUserGuide extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            icon_Bottom:16,
            icon_Right:0,
            isShowNewUserGuide: false,
            isShowNewUserGuideVedio: false,
            activeAuthorize: false,//激活授权按钮
            activeGifts: false,//激活授权按钮
            isShowNewUserGuideSteps: false,
            isShowAuthorizeDailog: false,
            isAthorizeSuccess: true,
            isAthorizeSuccessDailog: false,
            isShowBottomNewUserGuide: true,//新手指引，总开关
            isHideBottomNewUserGuide: false,
            isActiveBottomNewUserGuide: false,
            isShowAuthorizePlatromWrap:false,
            bottomNewUserGuideSteps: funSplitType()==2? //2为采购下单 
            [
                { id: 1, title: '授权平台货源', name: 'offerSearch', width: '140px', active: true,flex:1 },
                { id: 2, title: '关联商品', name: 'relevanceProduct', width: '140px', active: false ,flex:1},
                { id: 3, title: '下采购单', name: 'procurementOrder', width: '140px', active: false,flex:1 },
                { id: 4, title: '订单回流', name: 'orderBackflow', width: '190px', active: false,flex:1.5 },
                { id: 5, title: '自动售后', name: 'autoAfterSale', width: '230px', active: false,flex:1.8 },
            ]:funSplitType()==1?
            [
                { id: 1, title: '授权平台货源', name: 'offerSearch', width: '140px', active: true,flex:1 },
                { id: 2, title: '铺货设置', name: 'distributionSet', width: '140px', active: false ,flex:1},
                { id: 3, title: '铺货代发', name: 'proxyProduct', width: '280px', active: false ,flex:2}
            ]:
            [
                { id: 1, title: '授权平台货源', name: 'offerSearch', width: '140px', active: true,flex:1 },
                { id: 2, title: '铺货设置', name: 'distributionSet', width: '140px', active: false ,flex:1},
                { id: 3, title: '铺货代发', name: 'proxyProduct', width: '280px', active: false ,flex:2},
                { id: 4, title: '下采购单', name: 'procurementOrder', width: '140px', active: false,flex:1 },
                { id: 5, title: '订单回流', name: 'orderBackflow', width: '190px', active: false,flex:1.5 },
                { id: 6, title: '自动售后', name: 'autoAfterSale', width: '230px', active: false,flex:1.8 },
            ]
            ,
            quickGuideData:{
                HasListingSetting : false,
                HasRelationProduct : false,
                HasAutoConfirm : false,
                HasAutoRefund : false,
                OrderAutoOperateConfig : { IsAutoConfirm:false,IsAutoPay :false,IsAutoRefund:false},
                ListingStatistics : { SuccessCount:0,ErrorCount:0,DoingCount:0},
                ProductRelationStatistics : { },
                OrderStatistics : { 
                    DistributorOrderRelation:0,
                    OrderBackflowCount:0,
                    AutoAfterSaleCount:0,
                    WaitOrderBackflowCount:0,
                    WaitAfterSaleCount:0,
                    RelevanceProductCount:0,
                },
             },//快捷导航数据

             funSplitTypes: funSplitType(),
        };
        if(props.onRef){
            props.onRef(this);
        }
        const quickGuideDataStr = localStorage.getItem('components_navMenu_quickGuideData')
        if(quickGuideDataStr){
            try{
                const quickGuideData = JSON.parse(quickGuideDataStr)
                this.quickGuideDataProcess(quickGuideData)
                this.state.quickGuideData = quickGuideData;
            }catch(e){

            }
        }
        this.moving = false;  //是否能移动
        this.isClick=true;
        this.offsetX=0;
        this.offsetY=0;
    }
    componentDidMount() {

        document.onclick=()=>{
            this.setState({isShowAuthorizePlatromWrap:false})
        }

        let navOffset=getStorage("navOffset");
        if(navOffset){
            this.setState({
                icon_Bottom:navOffset.icon_Bottom,
                icon_Right:navOffset.icon_Right,

            })
        }
        //新手指引，总提示
        let isShowBottomNewUserGuideString = localStorage.getItem('isShowBottomNewUserGuide') || null;
        if(isShowBottomNewUserGuideString){
            let isShowBottomNewUserGuideObj=JSON.parse(isShowBottomNewUserGuideString);
            this.setState({
                isShowBottomNewUserGuide:isShowBottomNewUserGuideObj.isShowBottomNewUserGuide
            })
        }else{
            this.setState({
                isShowBottomNewUserGuide:true
            })
        }

        setTimeout(()=>{
            const loginShop = getLoginShopInfo();
            const data = {
                ShopId : loginShop.loginShopId,
                PlatformType : loginShop.loginShopPlatformType,
            }
            GetQuickGuideDataRequest(data).then(res =>{
                const resData = res.Data;
                if(res.Success){
                    this.quickGuideDataProcess(resData)
                    localStorage.setItem('components_navMenu_quickGuideData', JSON.stringify(resData))
                    this.setState({ })
                }else{
                    throw '快捷导航数据查询失败'
                }

            }).catch((e)=>{ localStorage.removeItem('components_navMenu_quickGuideData') });
            var zhukeTokenThree = getToken();
            
            if (!zhukeTokenThree && !this.props.history.location.pathname.includes('myAuth'))
            {
                // this.setState({ isShowNewUserGuide:true })

                this.setState({isShowBottomNewUserGuide:true})
            }
        },2500);
    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        // this.setState({
        //     isShowNewUserGuide: props.isShowNewUserGuide
        // })
    }
    quickGuideDataProcess(resData){
        const offerSearchStep = this.state.bottomNewUserGuideSteps.find(x => x.name == 'offerSearch')
        const distributionSetStep = this.state.bottomNewUserGuideSteps.find(x => x.name == 'distributionSet')
        const proxyProductStep = this.state.bottomNewUserGuideSteps.find(x => x.name == 'proxyProduct')
        const procurementOrderStep = this.state.bottomNewUserGuideSteps.find(x => x.name == 'procurementOrder')
        const orderBackflowStep = this.state.bottomNewUserGuideSteps.find(x => x.name == 'orderBackflow')
        const autoAfterSaleStep = this.state.bottomNewUserGuideSteps.find(x => x.name == 'autoAfterSale')
        const relevanceProductStep = this.state.bottomNewUserGuideSteps.find(x => x.name == 'relevanceProduct')

        if(funSplitType() == 2)
        {
            if(offerSearchStep){
                offerSearchStep.active = true
                resData.hasAuthAlibaba = isNotNull(getZkShopName())
                resData.hasAuthTaote = isNotNull(getTaoteId())
            }
            if(relevanceProductStep)
            {
                relevanceProductStep.active = true
            } 
            if(procurementOrderStep && resData.HasRelationProduct){
                procurementOrderStep.active = true
            }
            if(orderBackflowStep && resData.HasRelationProduct){
                orderBackflowStep.active = true
            }
            if(autoAfterSaleStep && resData.HasRelationProduct){
                autoAfterSaleStep.active = true
            }
        }
        else{
            if(offerSearchStep){
                offerSearchStep.active = true
                resData.hasAuthAlibaba = isNotNull(getZkShopName())
                resData.hasAuthTaote = isNotNull(getTaoteId())
            }
            if(distributionSetStep)
                distributionSetStep.active = true
            if(proxyProductStep && resData.HasListingSetting){
                proxyProductStep.active = true
            }
            if(procurementOrderStep && resData.HasRelationProduct){
                procurementOrderStep.active = true
            }
            if(orderBackflowStep && resData.HasRelationProduct){
                orderBackflowStep.active = true
            }
            if(autoAfterSaleStep && resData.HasRelationProduct){
                autoAfterSaleStep.active = true
            }
        }
        
        
        this.state.quickGuideData = resData
    }
    clickGuideAuthTaote(){
        this.addLog('点击授权淘特','quick_guide_look_tutorial_video_shop')
        this.urlLink('/myAuth');
    }
    isShowNewUserGuideVedio = (isTrue) => {
        if(isTrue){
            this.addLog('观看视频教程','quick_guide_look_tutorial_video_shop')
        }
        this.setState({ isShowNewUserGuideVedio: isTrue })
    }
    activeAuthorizeBtn = () => {
        this.addLog('1688订购授权弹窗-订购','quick_guide_click_alibaba_buy_shop')
        this.setState({
            activeAuthorize: true,
        })
    }
    gotoAuthorize = () => {
        this.addLog('1688订购授权弹窗-授权','quick_guide_click_alibaba_auth_shop')
        var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
        var succToUrl = "https://alizk.dgjapp.com/%23%2F?token=" + hasZhukeLoginShopTokens;
        //var succToUrl = systemConfig.serverLink() + '?token=' + hasZhukeLoginShopTokens
        succToUrl = 'false'
        var urls = "https://zk.dgjapp.com/auth/AlibabaByCommByAlone?SuccToUrl=" + succToUrl + "&rp=" + hasZhukeLoginShopTokens;

        if(this.state.funSplitTypes ==2)//双应用的第二个应用
           urls = "https://zk.dgjapp.com/auth/AlibabaByCommByAloneByOrder?SuccToUrl=" + succToUrl + "&rp=" + hasZhukeLoginShopTokens;
    

        window.open(urls,'_blank')
        this.setState({
            isShowAuthorizeDailog: true,
        })
    }
    checkAuthorize = () => {
        this.setState({
            isShowAuthorizeDailog: false,
            isShowCheckAuthorize: true
        })


        var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
        loadZhuKeToken(hasZhukeLoginShopTokens);
        setTimeout(() => {  //模拟 调接口  验测中  开发时要换掉的
            var zhukeTokenTwo = getToken();
            if (zhukeTokenTwo != "") {//验测授权成功
                if(this.props.successAuthBuyerShop)
                    this.props.successAuthBuyerShop();
                this.setState({
                    isShowCheckAuthorize: false,
                    isAthorizeSuccessDailog: true,
                    isAthorizeSuccess: true,
                    activeGifts: true,
                    isShowNewUserGuide:false,
                },()=>{
                    const loginShop = getLoginShopInfo();
                    const data = {
                        ShopId : loginShop.loginShopId,
                        PlatformType : loginShop.loginShopPlatformType,
                    }
                    GetQuickGuideDataRequest(data).then(res =>{
                        const resData = res.Data;
                        if(res.Success){
                            this.quickGuideDataProcess(resData)
                            localStorage.setItem('components_navMenu_quickGuideData', JSON.stringify(resData))
                            this.setState({ })
                        }else{
                            throw '快捷导航数据查询失败'
                        }
                    }).catch((e)=>{ localStorage.removeItem('components_navMenu_quickGuideData') });
                })
            } else {//验测授权失败
                this.setState({
                    isShowCheckAuthorize: false,
                    isAthorizeSuccessDailog: true,
                    isAthorizeSuccess: false,
                    activeGifts: false
                })
            }

            setTimeout(() => { //3秒后关闭检测授权结果提示
                this.setState({
                    isAthorizeSuccessDailog: false,
                })
            }, 3000)


        }, 2000)
    }
    loadQuickGuideData = ()=>{
        const loginShop = getLoginShopInfo();
        const data = {
            ShopId : loginShop.loginShopId,
            PlatformType : loginShop.loginShopPlatformType,
        }
        GetQuickGuideDataRequest(data).then(res =>{
            const resData = res.Data;
            if(res.Success){
                this.quickGuideDataProcess(resData)
                localStorage.setItem('components_navMenu_quickGuideData', JSON.stringify(resData))
                this.setState({ })
            }else{
                throw '快捷导航数据查询失败'
            }
        }).catch((e)=>{ localStorage.removeItem('components_navMenu_quickGuideData') });
    }
    isShowNewUserGuideSteps = (isTrue) => {
        if(isTrue == true){
            this.addLog('点击授权1688','quick_guide_click_alibaba__shop')
        }else{
            this.addLog('关闭授权弹窗','quick_guide_click_auth_confirm_shop')
        }
        this.setState({
            isShowNewUserGuideSteps: isTrue,
        })
    }
    closeBottomNewUserGuide = () => {   
        this.addLog('快捷导航-关闭快捷导航','quick_guide_close_shop')
        this.setState({ isHideBottomNewUserGuide: true })
        setTimeout(()=>{
            document.getElementById("showBottomNewUserGuideWrap").style.right=this.state.icon_Right+"px";
            document.getElementById("showBottomNewUserGuideWrap").style.bottom=this.state.icon_Bottom-30+"px";
        },1000)
        setTimeout(() => {
            this.setState({ isShowBottomNewUserGuide: false });
            let obj = {};
            obj.isShowBottomNewUserGuide = false;
            localStorage.setItem('isShowBottomNewUserGuide', JSON.stringify(obj));
        }, 2000)

    }


    urlLink = (name) => {
        let pathName = '/myAuth'
        if(name){
            pathName = name
        }
        const path = { pathname: pathName, state: { data: "" } }
        this.props.history.push(path);
    }
    showAuthorizeDailog = (e) => {
        e.nativeEvent.stopImmediatePropagation();
        this.setState({isShowAuthorizePlatromWrap:!this.state.isShowAuthorizePlatromWrap})

    }
    closeDailog=()=>{
        this.addLog('1688订购授权弹窗-关闭弹窗','quick_guide_click_close_alibaba_auth_steps_pop')
        this.setState({isShowNewUserGuideSteps:false})
    }
    closeNewUserGuideVedio=()=>{
        this.setState({isShowNewUserGuideVedio:false})
    }

    closeShowNewUserGuid=()=>{
        this.setState({isShowNewUserGuide:false})

    }

    isShowAliNewUserGuideSteps=(e)=>{
        //e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        this.setState({isShowNewUserGuideSteps:true})
    }
    closeShowNewUserGuide=()=>{
        this.addLog('点击授权弹窗关闭','quick_guide_click_close_auth_pop')
        this.setState({isShowNewUserGuide:false},()=>{
            if(this.props.closeShowNewUserGuide) this.props.closeShowNewUserGuide();
        })
    }
    clickQuickGuideAuth(sourcePlatform,e){
        if(sourcePlatform == 'taote'){
            this.addLog('快捷导航-点击授权淘特','quick_guide_click_step1_taote_auth_shop')
        }else{
            this.addLog('快捷导航-点击授权1688','quick_guide_click_step1_alibaba_auth_shop')
        }
        if(sourcePlatform == 'taote'){
            this.urlLink('/myAuth');
        }else{
             this.gotoAuthorize()
            // this.isShowAliNewUserGuideSteps(e);
        }
    }
    quickGuideToPage = (item,url)=>
    {
        if(!item.active)
            return;

        if(url && url.includes('shopProduct'))
        {
            this.addLog('快捷导航-关联商品','quick_guide_click_shopProduct_shop')
        }
        else if(url && url.includes('offerSearch'))
        {
            this.addLog('快捷导航-货源铺货','quick_guide_click_offerSearch_shop')
        }
        else if(url && url.includes('distributionSet'))
        {
            this.addLog('快捷导航-铺货设置','quick_guide_click_distributionSet_shop')
        }
        else if(url && url.includes('index'))
        {
            this.addLog('快捷导航-链接铺货','quick_guide_click_index_shop')
        }

        if(url=="/offerSearch" || url=="/index" || url=="/shopProduct"){
            this.setState({ isShowBottomNewUserGuide: false });
            let obj = {};
            obj.isShowBottomNewUserGuide = false;
            localStorage.setItem('isShowBottomNewUserGuide', JSON.stringify(obj));
        }

        this.urlLink(url);
    }
    addLog(remark,type){
        const loginToken = localStorage.getItem("hasZhukeLoginShopTokens") || null;
        const platformType = getLoginShopInfo().loginShopPlatformType;
        const loginShopId = getLoginShopInfo().loginShopId;
        const zkToken = getToken();
        const data ={
            SiteType : 'pc',
            OperatorType: type,
            Remark: remark,
            PlatformType:platformType,
            ShopId:loginShopId,
            token:loginToken,
        };
        if(zkToken){
            AddSiteLogRequest(data);
        }else{
            AddSiteLogByShopRequest(data)
        }
    }
    clickDrawGift(){
        this.addLog('1688订购授权弹窗-领取大礼包','quick_guide_click_draw_gift_shop')
        window.open('https://app.1688.com/3b2a2e82.html?activityCode=0185565f30b64740bd1a439b0c1a360d','_blank')
    }
    onMouseUp(){
        this.moving=false;
        window.onmouseup=null;
        window.onmousemove=null;

    }
    onMouseMove(e) {
        if(this.moving){
            this.isClick=false;
            let dx = this.offsetX-e.clientX+this.targetRight;
            let dy = this.offsetY-e.clientY+this.targetTop;
            let scrollWidth=document.body.scrollWidth;
            let innerHeight=window.innerHeight?window.innerHeight:0;
            if(innerHeight){
                if(dy>=innerHeight-100){
                    dy=innerHeight-100
                }
            }
            if(dx<=0){
                dx=0;
            }
            if(dy<=0){
                dy=0;
            }
            if(dx>=scrollWidth-120){
                dx=scrollWidth-120;
            }
            var navOffset={};
            navOffset.icon_Right=dx;
            navOffset.icon_Bottom=dy;
            setStorage("navOffset",navOffset)
            this.setState({
                icon_Right:dx,
                icon_Bottom:dy,
            })
 
        }
    }
    onMouseDown(e){
        window.onmouseup = e => this.onMouseUp(e);
        window.onmousemove = e => this.onMouseMove(e);
        this.moving=true;
        this.offsetX=e.clientX;
        this.offsetY=e.clientY;
        this.isClick=true;

        this.targetRight=this.state.icon_Right;
        this.targetTop=this.state.icon_Bottom;

    }

    showBottomNewUserGuide = () => {
        let icon_Right=this.state.icon_Right;
        let icon_Bottom=this.state.icon_Bottom;
        if(icon_Right==this.targetRight && icon_Bottom==this.targetTop){

            this.addLog('快捷导航-打开导航栏','quick_guide_open_shop')
            this.setState({
                isShowBottomNewUserGuide: true,
                isHideBottomNewUserGuide: false
            },()=>{
                let obj = {};
                obj.isShowBottomNewUserGuide = true;
                localStorage.setItem('isShowBottomNewUserGuide', JSON.stringify(obj));
            })

        }


    }

    render() {

        let { isShowNewUserGuide, isShowNewUserGuideVedio, activeAuthorize, isShowAuthorizeDailog, isShowCheckAuthorize,
            isAthorizeSuccess, isAthorizeSuccessDailog, activeGifts, isShowNewUserGuideSteps, isShowBottomNewUserGuide,
            isHideBottomNewUserGuide, bottomNewUserGuideSteps,isShowAuthorizePlatromWrap
        } = this.state;

        let bottomNewUserGuideClass = 'bottomNewUserGuideWrap';
        bottomNewUserGuideClass = isHideBottomNewUserGuide ? 'hideBottomNewUserGuide ' + bottomNewUserGuideClass : bottomNewUserGuideClass;
        let styleClass=isHideBottomNewUserGuide ? {top:this.state.icon_Bottom+"px",right:this.state.icon_Right+"px"}:{};


        let elems =
            <div style={{position:"absolute",zIndex:1000}}>

                <ShowModal showModal={isShowNewUserGuide} titleName={"授权货源账号"} width={'400px'} hideBtn={true} showLeftTopBtn={true}  cancelDailog={this.closeShowNewUserGuide}>
                    <div className='newUserGuideWrap'>
                        <div className="newUserGuideWrap-text">
                            <span>店管家新增淘特货源正式上线，您现在可以授权淘特</span>
                            <span>货源进行铺货</span>
                        </div>
                        <ul className="newUserGuideWrap-main">
                            <li className="newUserGuideWrap-main-item" onClick={() => this.clickGuideAuthTaote()}>授权淘特货源(无需订购应用)</li>
                            <li className="newUserGuideWrap-main-item" onClick={() => this.isShowNewUserGuideSteps(true)}>授权1688货源(需订购应用)</li>
                        </ul>
                    </div>
                </ShowModal>

                <ShowModal showModal={isShowNewUserGuideSteps} wrapSkin="newUserGuideStepsSkin" titleName={"授权货源账号"} width={'520px'} hideBtn={true} showLeftTopBtn={true} cancelDailog={this.closeDailog}>
                    <ul className='newUserGuideStepsWrap'>
                        <li className='newUserGuideStepsWrap-item'>
                            <div className='newUserGuideStepsWrap-item-left'>
                                <span>1</span>
                            </div>
                            <div className='newUserGuideStepsWrap-item-mid'>
                                <div className='newUserGuideStepsWrap-item-mid-title'>
                                    <span>了解授权</span>
                                    <span>观看视频更利于了解授权操作流程</span>
                                </div>
                                <div className='newUserGuideStepsWrap-item-mid-content'>授权1688货源可以进行铺货和实现订单采购</div>
                            </div>
                            <div className='newUserGuideStepsWrap-item-right'>
                                <span onClick={() => this.isShowNewUserGuideVedio(true)}>视频教程</span>
                            </div>
                        </li>
                        <li className='newUserGuideStepsWrap-item'>
                            <div className='newUserGuideStepsWrap-item-left'>
                                <span>2</span>
                            </div>
                            <div className='newUserGuideStepsWrap-item-mid'>
                                <div className='newUserGuideStepsWrap-item-mid-title'>
                                    <span>授权应用</span>
                                    <span>免费版只能铺货5次</span>
                                </div>
                                <div className='newUserGuideStepsWrap-item-mid-content'>开始授权1688服务市场【店管家-铺货代发】</div>
                            </div>
                            <div className='newUserGuideStepsWrap-item-right'>
                                <span onClick={() => this.gotoAuthorize()}>去授权</span>
                            </div>
                        </li>
                    </ul>
                </ShowModal>

                {/* <ShowModal showModal={isShowNewUserGuideSteps} titleName={"授权货源账号"} width={'1040px'} hideBtn={true} showLeftTopBtn={true} cancelDailog={this.closeDailog}>
                    <ul className='newUserGuideSteps'>
                        <li className='newUserGuideSteps-item'>
                            <div className='newUserGuideSteps-item-title'>
                                <span>了解授权</span>
                                <i>1</i>
                            </div>
                            <div className='newUserGuideSteps-item-main'>
                                <div className='newUserGuideSteps-item-main-up'>
                                    <span>授权1688货源可以进行铺货和</span>
                                    <span>实现订单采购</span>
                                </div>
                                <div className='newUserGuideSteps-item-main-mid'>
                                    <span>观看视频更利于了解授权操作流程</span>
                                </div>
                                <div className='newUserGuideSteps-item-main-down'>
                                    <span className='active btn' onClick={() => this.isShowNewUserGuideVedio(true)}>视频教程</span>
                                </div>
                            </div>
                        </li>
                        <li className='newUserGuideSteps-item'>
                            <div className='newUserGuideSteps-item-title'>
                                <span>订购应用</span>
                                <i>2</i>
                            </div>
                            <div className='newUserGuideSteps-item-main'>
                                <div className='newUserGuideSteps-item-main-up'>
                                    <span>在店铺铺货需订购1688服务市</span>
                                    <span>场【店管家-铺货代发】，支持</span>
                                    <span style={{ fontWeight: 700 }}>3个月免费试用</span>
                                </div>
                                <div className='newUserGuideSteps-item-main-mid'>
                                    <span>免费版只能铺货5次</span>
                                </div>
                                <div className='newUserGuideSteps-item-main-down'>
                                    <a className='active btn' onClick={() => this.activeAuthorizeBtn()} href='https://pc.1688.com/product/sod/confirm/sodCommon.htm?productCode=iZqTVp2laV4TtrT9HOO5hQzpWkdV2MuhHHQ6rXPSVZo%3D' target='_blank'>去订购</a>
                                </div>
                            </div>
                        </li>
                        <li className='newUserGuideSteps-item'>
                            <div className='newUserGuideSteps-item-title'>
                                <span>授权货源账号</span>
                                <i>3</i>
                            </div>
                            <div className='newUserGuideSteps-item-main'>
                                <div className='newUserGuideSteps-item-main-up'>
                                    <span>订购后，需授权1688服务市场</span>
                                    <span>【店管家-铺货代发】</span>
                                </div>
                                <div className='newUserGuideSteps-item-main-mid'>
                                    <span>注意授权的是订购1688应用账号</span>
                                </div>
                                <div className='newUserGuideSteps-item-main-down'>
                                    {
                                        activeAuthorize ?
                                            <span className='btn active' onClick={() => this.gotoAuthorize()}>去授权</span> :
                                            <span className='btn'>去授权</span>
                                    }

                                </div>
                            </div>
                        </li>
                        <li className='newUserGuideSteps-item'>
                            <div className='newUserGuideSteps-item-title'>
                                <span>完成操作</span>
                                <i>4</i>
                            </div>
                            <div className='newUserGuideSteps-item-main'>
                                <div className='newUserGuideSteps-item-main-up'>
                                    <span>提示授权成功后返回软件，就可</span>
                                    <span>以开始铺货到抖店店铺</span>
                                </div>
                                <div className='newUserGuideSteps-item-main-mid'>
                                    <span>授权成功领取
                                        {
                                            activeGifts ?
                                                <span className='dColor hover' onClick={()=>{ this.clickDrawGift()}} target='_blank'>回馈大礼包！</span> :
                                                <i>回馈大礼包！</i>
                                        }
                                    </span>
                                </div>
                                <div className='newUserGuideSteps-item-main-down'>
                                    {
                                        activeGifts ?
                                            <span className='btn active' onClick={() => this.isShowNewUserGuideSteps(false)}>我知道了</span> :
                                            <span className='btn'>我知道了</span>
                                    }

                                </div>
                            </div>
                        </li>
                    </ul>
                </ShowModal> */}
                <ShowModal showModal={isShowNewUserGuideVedio} titleName={"授权视频"} width={'1040px'} skin={'newUserGuideVedioskin'} hideBtn={true} showLeftTopBtn={true} cancelDailog={this.closeNewUserGuideVedio} >
                    <div className='newUserGuideVedio'>
                        <video controls="controls" width={'1000px'} height={'560px'} poster="https://www.dgjapp.com/public/upload/newUserGuide-ph-vedio-img.jpg">
                            <source src="https://www.dgjapp.com/public/upload/newUserGuide-ph-vedio.mp4" type="video/mp4" />
                        </video>
                        <div className='newUserGuideVedio-btn'>
                            <span onClick={() => this.isShowNewUserGuideVedio(false)}>我知道了</span>
                        </div>
                    </div>
                </ShowModal>

                <ShowModal showModal={isShowAuthorizeDailog} titleName={"确定"} width={'540px'} sureDailog={this.checkAuthorize} cancelDailog={this.checkAuthorize} showLeftTopBtn={true}>
                    <div className='authorizeDailogWrap'>
                        <i className='iconfont icon-tips'></i>
                        <span>您是否已经完成授权？</span>
                    </div>
                </ShowModal>


                <ShowModal showModal={isShowCheckAuthorize} hideTitle={true} width={'400px'} hideBtn={true}>
                    <div className='checkAuthorizeDailog'>
                        <Loading className='checkAuthorizeDailog-load' />
                        <span>正在检测是否授权成功</span>
                    </div>
                </ShowModal>

                <ShowModal showModal={isAthorizeSuccessDailog} hideTitle={true} width={'400px'} hideBtn={true}>
                    {
                        isAthorizeSuccess ?
                            <div className='checkAuthorizeDailog' style={{ paddingTop: '30px' }}>
                                <i className='iconfont icon-dagou1'></i>
                                <span className='checkAuthorizeDailog-su'>授权成功！</span>
                            </div> : <div className='checkAuthorizeDailog' style={{ paddingTop: '30px' }}>
                                <i className='iconfont icon-add-fill-hover-copy'></i>
                                <span className='checkAuthorizeDailog-su'>授权失败！</span>
                            </div>
                    }
                </ShowModal>




                {
                    isShowBottomNewUserGuide ?
                        <div id="showBottomNewUserGuideWrap" className={bottomNewUserGuideClass} >
                            <div className='bottomNewUserGuideWrap-title'>
                                <span className='bottomNewUserGuideWrap-title-left'>铺货代发流程</span>
                                <span className='iconfont icon-chuyidong' onClick={() => this.closeBottomNewUserGuide()}></span>
                            </div>
                            <ul className='bottomNewUserGuideWrap-main'>
                                <li className='bottomNewUserGuideWrap-main-left' onClick={() => this.closeBottomNewUserGuide()}>
                                    <span>收</span>
                                    <span>起</span>
                                    <i className='iconfont icon-xiangxia'></i>
                                </li>

                                {
                                    bottomNewUserGuideSteps.map((item, i) =>

                                        <li className={item.active ? 'bottomNewUserGuideWrap-item active' : 'bottomNewUserGuideWrap-item'} style={{ width: item.width,flex:item.flex }}>
                                            <div className='bottomNewUserGuideWrap-item-up'>
                                                <span className='bottomNewUserGuideWrap-item-up-num'>{item.id}</span>
                                                <span className='bottomNewUserGuideWrap-item-up-title'>{item.title}</span>
                                            </div>
                                            {
                                                item.name == "offerSearch" ?
                                                    <div>
                                                        <div className='bottomNewUserGuideWrap-item-mid'>
                                                            <span className='bottomNewUserGuideWrap-item-mid-title'>授权1688</span>
                                                            {
                                                                !this.state.quickGuideData.hasAuthAlibaba && !this.state.quickGuideData.hasAuthTaote?
                                                                    <span className='bottomNewUserGuideWrap-item-mid-status fColor'>未授权</span>:null
                                                            }
                                                            {/* {
                                                                this.state.quickGuideData.hasAuthAlibaba && this.state.quickGuideData.hasAuthTaote? 
                                                                <span className='bottomNewUserGuideWrap-item-mid-status sColor haveActive'>已授权1688和淘特</span> :null
                                                            } */}
                                                            {
                                                                this.state.quickGuideData.hasAuthAlibaba ?//&& !this.state.quickGuideData.hasAuthTaote? 
                                                                <span className='bottomNewUserGuideWrap-item-mid-status sColor haveActive'>已授权1688</span> :null
                                                            }
                                                            {/* {
                                                                !this.state.quickGuideData.hasAuthAlibaba && this.state.quickGuideData.hasAuthTaote ? 
                                                                <span className='bottomNewUserGuideWrap-item-mid-status sColor haveActive'>已授权淘特</span> :null
                                                            } */}
                                                        </div>
                                                        <div className='bottomNewUserGuideWrap-item-down'>
                                                            {
                                                                isShowAuthorizePlatromWrap ? 
                                                                <ul className='authorizePlatromWrap'>
                                                                    <li className='authorizePlatromWrap-item' onClick={(e) => this.clickQuickGuideAuth('',e)}>授权1688货源</li>
                                                                    {/* <li className='authorizePlatromWrap-item' onClick={() => this.clickQuickGuideAuth('taote')}>授权淘特货源</li> */}
                                                                </ul> : null
                                                            }
                                                            {
                                                                this.state.quickGuideData.hasAuthAlibaba || this.state.quickGuideData.hasAuthTaote ? 
                                                                    <span className='bottomNewUserGuideWrap-item-down-btn bottomNewUserGuideWrap-item-down-btn-myauth' onClick={(e) => this.quickGuideToPage(item,'/myAuth')}>查看授权</span>
                                                                    :<span className='bottomNewUserGuideWrap-item-down-btn bottomNewUserGuideWrap-item-down-btn-myauth' onClick={(e) => this.showAuthorizeDailog(e)}>去授权</span>
                                                            }
                                                        </div>
                                                    </div> : null
                                            }
                                            {
                                                item.name == "distributionSet" ?
                                                    <div>
                                                        <div className='bottomNewUserGuideWrap-item-mid'>
                                                            <span className='bottomNewUserGuideWrap-item-mid-title'>铺货设置</span>
                                                            {
                                                                this.state.quickGuideData.HasListingSetting ? 
                                                                <span className='bottomNewUserGuideWrap-item-mid-status sColor'>已设置</span>:
                                                                <span className='bottomNewUserGuideWrap-item-mid-status fColor'>未设置</span>
                                                            }
                                                        </div>
                                                        <div className='bottomNewUserGuideWrap-item-down'>
                                                            <span className='bottomNewUserGuideWrap-item-down-btn' onClick={()=>{ this.quickGuideToPage(item,'/distributionSet') }}>去设置</span>
                                                        </div>
                                                    </div> : null
                                            }
                                            {
                                                item.name == "proxyProduct" ?
                                                    <ul className='bottomNewUserGuideWrap-ul'>
                                                        <li className='bottomNewUserGuideWrap-ul-li'>
                                                            <span className='bottomNewUserGuideWrap-ul-title'>铺货中</span>
                                                            <span className='bottomNewUserGuideWrap-ul-num'><i className='fColor nums'>{this.state.quickGuideData.ListingStatistics.DoingCount}</i> 个</span>
                                                            <span className='bottomNewUserGuideWrap-ul-li-btn' onClick={()=>{ this.quickGuideToPage(item,'/offerSearch') }}>货源铺货</span>
                                                        </li>
                                                        <li className='bottomNewUserGuideWrap-ul-li'>
                                                            <span className='bottomNewUserGuideWrap-ul-title'>铺货成功</span>
                                                            <span className='bottomNewUserGuideWrap-ul-num'><i className='sColor nums'>{this.state.quickGuideData.ListingStatistics.SuccessCount}</i> 个</span>
                                                            <span className='bottomNewUserGuideWrap-ul-li-btn'  onClick={()=>{ this.quickGuideToPage(item,'/index') }}>链接铺货</span>
                                                        </li>
                                                        {
                                                            funSplitType() != 1?
                                                            <li className='bottomNewUserGuideWrap-ul-li'>
                                                                <span className='bottomNewUserGuideWrap-ul-title'>铺货失败</span>
                                                                <span className='bottomNewUserGuideWrap-ul-num'><i className='fColor nums'>{this.state.quickGuideData.ListingStatistics.ErrorCount}</i> 个</span>
                                                                <span className='bottomNewUserGuideWrap-ul-li-btn'  onClick={()=>{ this.quickGuideToPage(item,'/shopProduct') }}>关联商品</span>
                                                            </li>:null
                                                        }
                                                        
                                                    </ul> : null
                                            }
                                            {
                                                item.name == "procurementOrder" ?
                                                    <div>
                                                        <div className='bottomNewUserGuideWrap-item-mid'>
                                                            <span className='bottomNewUserGuideWrap-item-mid-title'>待采购订单</span>
                                                            <span className='bottomNewUserGuideWrap-item-mid-status'><i className='fColor nums'>{this.state.quickGuideData.OrderStatistics.DistributorOrderRelation}</i> 笔</span>
                                                        </div>
                                                        <div className='bottomNewUserGuideWrap-item-down'>
                                                            <span className='bottomNewUserGuideWrap-item-down-btn'   onClick={()=>{ this.quickGuideToPage(item,'/orderList') }}>去下采购单</span>
                                                        </div>
                                                    </div> : null
                                            }
                                            {
                                                item.name == "orderBackflow" ?
                                                    <div>
                                                        <ul className='bottomNewUserGuideWrap-ul'>
                                                            <li className='bottomNewUserGuideWrap-ul-li'>
                                                                <span className='bottomNewUserGuideWrap-ul-title'>待回流订单</span>
                                                                <span className='bottomNewUserGuideWrap-ul-num'><i className='fColor nums'>{this.state.quickGuideData.OrderStatistics.WaitOrderBackflowCount}</i> 笔</span>
                                                            </li>
                                                            <li className='bottomNewUserGuideWrap-ul-li'>
                                                                <span className='bottomNewUserGuideWrap-ul-title'>已回流订单</span>
                                                                <span className='bottomNewUserGuideWrap-ul-num'><i className='fColor nums'>{this.state.quickGuideData.OrderStatistics.OrderBackflowCount}</i> 笔</span>
                                                            </li>
                                                        </ul>
                                                        <div className='bottomNewUserGuideWrap-item-down'>
                                                            <span className='comomBtn' onClick={()=>{ this.quickGuideToPage(item,'/orderBackflowSet') }} >开启自动回流设置</span>
                                                        </div>
                                                    </div> : null
                                            }
                                            {
                                                item.name == "autoAfterSale" ?
                                                    <div>
                                                        <ul className='bottomNewUserGuideWrap-ul'>
                                                            <li className='bottomNewUserGuideWrap-ul-li'>
                                                                <span className='bottomNewUserGuideWrap-ul-title'>待退款订单</span>
                                                                <span className='bottomNewUserGuideWrap-ul-num'><i className='fColor nums'>{this.state.quickGuideData.OrderStatistics.WaitAfterSaleCount}</i> 笔</span>
                                                            </li>
                                                            <li className='bottomNewUserGuideWrap-ul-li'>
                                                                <span className='bottomNewUserGuideWrap-ul-title'>已完成订单</span>
                                                                <span className='bottomNewUserGuideWrap-ul-num'><i className='sColor nums'>{this.state.quickGuideData.OrderStatistics.AutoAfterSaleCount}</i> 笔</span>
                                                            </li>
                                                        </ul>
                                                        <div className='bottomNewUserGuideWrap-item-down'>
                                                            <span className='comomBtn'  onClick={()=>{ this.quickGuideToPage(item,'/autoAfterSaleSet') }}>开启自动售后设置</span>
                                                        </div>
                                                    </div> : null
                                            }

                                            {
                                                item.name == "relevanceProduct"?
                                                <div>
                                                        <div className='bottomNewUserGuideWrap-item-mid'>
                                                            <span className='bottomNewUserGuideWrap-item-mid-title'>代销商品</span>
                                                            <span className='bottomNewUserGuideWrap-item-mid-status'><i className='fColor nums'>{this.state.quickGuideData.ProductRelationStatistics.RelationCount}</i> 个</span>
                                                        </div>
                                                        <div className='bottomNewUserGuideWrap-item-down'>
                                                            <span className='bottomNewUserGuideWrap-item-down-btn'  onClick={()=>{ this.quickGuideToPage(item,'/shopProduct') }}>去关联</span>
                                                        </div>
                                                    </div> : null
                                            }


                                            


                                        </li>

                                    )
                                }
                            </ul>
                        </div> :
                        <div title="可托动" className='bottomNewUserGuideIcon' style={{right:this.state.icon_Right+'px',bottom:this.state.icon_Bottom + 'px'}}
                            onClick={() => this.showBottomNewUserGuide()}
                            onMouseDown={e => this.onMouseDown(e)}
                            >
                            <img draggable="false" src="data:image/png;base64,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" alt="" />
                        </div>
                }

            </div>
        return (
            elems
        );
    }
}

export default withRouter(NewUserGuide);



// WEBPACK FOOTER //
// ./src/components/newUserGuide/index.jsx